import React from 'react'
import PropTypes from 'prop-types'
import { size } from 'lodash'
import { connect } from 'react-redux'
import { pure, compose, renderNothing, branch } from 'recompose'
import Snackbar from '@material-ui/core/Snackbar'
import IconButton from '@material-ui/core/IconButton'
import CloseIcon from '@material-ui/icons/Close'
import * as actions from '../actions'
import { withStyles } from '@material-ui/core/styles'


import classNames from 'classnames';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import ErrorIcon from '@material-ui/icons/Error';
import InfoIcon from '@material-ui/icons/Info';

import green from '@material-ui/core/colors/green';
import amber from '@material-ui/core/colors/amber';

import SnackbarContent from '@material-ui/core/SnackbarContent';


import WarningIcon from '@material-ui/icons/Warning';

const styles = {
  buttonRoot: {
    color: 'white'
  }
}
const variantIcon = {
  success: CheckCircleIcon,
  warning: WarningIcon,
  error: ErrorIcon,
  info: InfoIcon,
};
const styles1 = theme => ({
  buttonRoot: {
    color: 'white'
  },
  success: {
    backgroundColor: green[600],
  },
  error: {
    backgroundColor: theme.palette.error.dark,
  },
  info: {
    backgroundColor: theme.palette.primary.dark,
  },
  warning: {
    backgroundColor: amber[700],
  },
  icon: {
    fontSize: 20,
  },
  iconVariant: {
    opacity: 0.9,
    marginRight: theme.spacing.unit,
  },
  message: {
    display: 'flex',
    alignItems: 'center',
  },
});
export const Notifications = ({
  allIds,
  byId,
  dismissNotification,
  classes,
  className
}) => {
  return (


    <div>
      {allIds.map(id => {
        let not = byId[id];
        let variant = "info"
        let Icon = variantIcon[variant];
        if (not && not.type) {
          variant = not.type
          Icon = variantIcon[variant];
        }
        return (
          <Snackbar
            anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
            key={id}
            open

          >
            <SnackbarContent
              key={"sc" + id}
              className={classNames(classes[variant], className)}
              aria-describedby="client-snackbar"

              message={
                <span id="client-snackbar" className={classNames(classes[variant], className)}>
                  <Icon className={classNames(classes.icon, classes.iconVariant)} />
                  {not.message}
                </span>
              }
              action={
                <IconButton
                  onClick={() => dismissNotification(id)}
                  classes={{ root: classes.buttonRoot }}>
                  <CloseIcon />
                </IconButton>
              }
            />

          </Snackbar>
        )
      })}
    </div>
  )
}

Notifications.propTypes = {
  allIds: PropTypes.array.isRequired,
  byId: PropTypes.object.isRequired,
  classes: PropTypes.object.isRequired,
  dismissNotification: PropTypes.func.isRequired
}

export default compose(
  pure,
  withStyles(styles1),
  connect(
    ({ notifications: { allIds, byId } }) => ({ allIds, byId }),
    actions
  ),
  branch(props => !size(props.allIds), renderNothing) // only render if notifications exist
)(Notifications)



// WEBPACK FOOTER //
// ./src/modules/notification/components/Notifications.js